import React from 'react';

export const Section = ({ title, children, testid }) => (
  <section className="bg-white/5 border border-white/10 rounded-xl p-5 mb-5" data-testid={testid}>
    <h2 className="text-sm uppercase tracking-wider text-teal-300 font-semibold mb-4">{title}</h2>
    {children}
  </section>
);

export const Field = ({ label, children, required }) => (
  <label className="block">
    <span className="text-xs uppercase tracking-wider text-slate-400 block mb-1">
      {label} {required && <span className="text-red-400">*</span>}
    </span>
    {children}
  </label>
);
